import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useEffect } from 'react';
import MobileStepper from '@mui/material/MobileStepper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import { useSettings } from '../context/SettingsContext';
import useWidgetStore from '../store/useWidgetStore';
import BookingSummary from '../partials/BookingSummary';
import LanguageSelect from '../partials/LanguageSelect';
import { isMobile } from '../../../helpers/browser';
import { Badge, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
const BasicNav = ({ children }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const theme = useTheme();
    const navigate = useNavigate();
    const { allowSwitch, supportedLanguages, t, ts } = useI18N();
    const { widgetMode, orientation, defaultOpened, hasGroupedShop, hasShop, showCategories, showDetails } = useSettings();
    const [hasBack, setHasBack] = useState(true);
    const [showSummary, setShowSummary] = useState(false);
    const [hasProducts, setHasProducts] = useState(false);
    const [total, setTotal] = useState(0);
    const { hasBooking, consumer, booking, cart } = useWidgetStore();
    const [showUser, setShowUser] = useState(false);
    const [title, setTitle] = useState();
    const flow = useFlow();
    const isDesktop = window.screen.width > 500;
    const isTriggerButton = ["triggerButtonLeft", "triggerButtonRight"].includes(widgetMode);
    useEffect(() => {
        var _a, _b;
        // don't render the badge on the thankYou page. We can't reset it there, because we need it to display a summary of the cart
        setHasProducts(hasShop
            && total > 0
            && (cart.lines.filter((line) => !["requiredPurchase", "appointment"].includes(line.origin) && line.productType !== "appointment").length > 0
                || ((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0)
            && ((_b = flow.currentView) === null || _b === void 0 ? void 0 : _b.route.route) !== "thankYou");
    }, [cart, total, flow.currentView]);
    useEffect(() => {
        var _a, _b;
        let _total = 0;
        if (cart.lines.length > 0) {
            let quantities = cart.lines.map((line) => {
                var _a;
                return ["requiredPurchase", "appointment"].includes(line.origin)
                    || line.productType === "appointment"
                    || (line.productType === "subscription" && ((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) ? 0 : line.quantity;
            });
            if (quantities.length > 0) {
                _total = quantities.reduce((quantity, total) => quantity + total);
            }
        }
        if (((_a = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            _total += (_b = booking === null || booking === void 0 ? void 0 : booking.appointments) === null || _b === void 0 ? void 0 : _b.length;
        }
        setTotal(_total);
    }, [cart, booking === null || booking === void 0 ? void 0 : booking.appointments]);
    useEffect(() => {
        var _a;
        if (flow === null || flow === void 0 ? void 0 : flow.checkFlow) {
            flow === null || flow === void 0 ? void 0 : flow.checkFlow((_a = flow.direction) !== null && _a !== void 0 ? _a : "next");
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (flow === null || flow === void 0 ? void 0 : flow.insideFlow) {
            let view = flow.views[flow.currentStep];
            setHasBack(!(((_a = view === null || view === void 0 ? void 0 : view.config) === null || _a === void 0 ? void 0 : _a.hasPrevious) !== undefined && !((_b = view === null || view === void 0 ? void 0 : view.config) === null || _b === void 0 ? void 0 : _b.hasPrevious)) && flow.currentStep > 0);
        }
        setShowSummary(hasBooking === true && !['select', 'select1', 'select2', 'payment', 'mandate', 'mandate1', 'thankYou', 'shop', 'category', 'detail', 'summary'].includes((_d = (_c = flow === null || flow === void 0 ? void 0 : flow.currentRoute) === null || _c === void 0 ? void 0 : _c.route) !== null && _d !== void 0 ? _d : ''));
        setShowUser(!!(consumer === null || consumer === void 0 ? void 0 : consumer.email));
    }, [flow === null || flow === void 0 ? void 0 : flow.currentRoute, flow.currentView]);
    useEffect(() => {
        var _a, _b;
        let currentRoute = location.hash.substring(12);
        if (!(flow === null || flow === void 0 ? void 0 : flow.insideFlow) || currentRoute.includes('/')) {
            setTitle((_a = flow.title) !== null && _a !== void 0 ? _a : (_b = flow.currentRoute) === null || _b === void 0 ? void 0 : _b.label);
        }
    }, [flow.title, flow.currentRoute]);
    let _height = isDesktop
        ? (widgetMode === 'standalone'
            // on whole widget, marginY 60px = 120, appbar 48px, navigation dots 32px, 1px border = 201px
            ? 'min(1000px, calc(100dvh - 201px))'
            // 100% viewport height, appbar 48px, navigation dots 32px, 2x 1px border, 16px shadow around the widget Paper
            : 'min(1000px,calc(100dvh - 98px))')
        // mobile mode is always 100% viewport height, minus appbar 48px, navigation dots 32px, 2x border 1px = 82px
        : 'min(1000px, calc(100dvh - 88px))';
    let currentRoute = location.hash.substring(12);
    if (currentRoute.includes('/'))
        currentRoute = currentRoute.substring(0, currentRoute.indexOf('/'));
    const goShoppingCart = () => {
        navigate("/oa_widget_shoppingCart");
    };
    return (_jsxs(_Fragment, { children: [_jsx(AppBar, { sx: Object.assign(Object.assign(Object.assign({ zIndex: 1000, position: 'sticky', top: 0, left: 0, right: 0, borderRadius: isDesktop ? '16px 16px 0 0' : 0, backgroundColor: theme.palette.background.default, borderBottom: theme.palette.mode === 'dark' ? '#333 1px solid' : '#fafafa 1px solid' }, (!isDesktop && {
                    boxShadow: 'none'
                })), { maxWidth: '500px' }), (orientation === 'horizontal' && isDesktop && {
                    maxWidth: '100%',
                    left: 0
                })), children: _jsxs(Toolbar, { variant: "dense", sx: {
                        paddingX: '8px !important',
                        color: theme.palette.text.primary
                    }, children: [_jsxs(_Fragment, { children: [hasBack && flow.currentStep > 0 && (_jsx(Button, { size: "large", onClick: flow.onPrevious, sx: {
                                        color: 'inherit',
                                        paddingX: 0,
                                        minWidth: 0,
                                        width: '24px'
                                    }, children: theme.direction === 'rtl' ? (_jsx(KeyboardArrowRight, {})) : (_jsx(KeyboardArrowLeft, {})) })), !hasBack && !flow.insideFlow && (_jsx(Button, { size: "large", onClick: flow.restart, sx: {
                                        color: 'inherit',
                                        paddingX: 0,
                                        minWidth: 0,
                                        width: '24px'
                                    }, children: theme.direction === 'rtl' ? (_jsx(KeyboardArrowRight, {})) : (_jsx(KeyboardArrowLeft, {})) })), flow.currentStep === 0 && allowSwitch && (supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.length) > 1 && !['return', 'detail', 'category', 'shop', 'crossselling'].includes(currentRoute) && (_jsx(Box, { children: _jsx(LanguageSelect, { config: { size: 30 } }) }))] }), _jsx(Typography, { variant: "h6", component: "div", sx: Object.assign(Object.assign({ flexGrow: 1, textAlign: 'center', fontWeight: 500, fontSize: '1.25rem', width: '100%', color: theme.palette.text.primary, margin: 0 }, (orientation === "vertical" && {
                                marginRight: (hasBack && flow.currentStep > 0)
                                    ? hasProducts
                                        ? '-24px'
                                        : '24px'
                                    : (hasBack || hasProducts) && flow.currentStep === 0
                                        ? '-48px'
                                        : "0" // take into acount back button
                            })), (orientation === "horizontal" && {
                                paddingLeft: hasProducts
                                    ? hasBack && flow.currentStep > 0
                                        ? '30px' : '48px'
                                    : 0
                            })), children: flow.insideFlow && !location.hash.substring(12).includes('/')
                                ? ((_a = flow.currentRoute) === null || _a === void 0 ? void 0 : _a.route) === 'accountDetails1'
                                    ? t('Persoonlijke gegevens') // dirty hack for now, will give subroutes proper titles and next buttons later
                                    : t((_c = (_b = flow.currentRoute) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : '')
                                : title !== null && title !== void 0 ? title : t('title') }), hasProducts && (_jsx(IconButton, { size: "large", "aria-label": ts("Je hebt _quantity_ producten in je winkelwagen", { quantity: total }), color: "inherit", sx: Object.assign({ position: 'relative', top: '4px' }, (isTriggerButton && {
                                top: 0,
                                right: '40px'
                            })), onClick: goShoppingCart, children: _jsx(Badge, { badgeContent: total, color: "error", children: _jsx(ShoppingCartIcon, {}) }) }))] }) }), _jsxs(Box, { sx: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (orientation === 'horizontal' && Object.assign(Object.assign({}, (isDesktop && widgetMode === "default" && {
                    height: 'calc(100dvh - 100px)', // the widget including header and navigation dots is 100dvh - 16px, where 100dvh is the iframe which itself is max 80dvh of the embedding site
                    minHeight: 'calc(100dvh - 100px)',
                    paddingBottom: '16px',
                    // overflowY: 'scroll'
                    overflowY: ((_d = flow.currentRoute) === null || _d === void 0 ? void 0 : _d.route) == currentRoute && ([
                        //     //'select',
                        'select1', // for now, the current "static" widget only has a grouped object list on the first page, so hardcode this and fix this properly later on. I'm not sure what's the best way to fix this.
                        //     // The issue that needs resolving is the scrollbar. I don't want a scrollbar next to the category tabs, only in the content below. But getting those tabs outside of the scrollable part is a bit tricky
                        //     //    'select2'
                    ].includes((_e = flow.currentRoute) === null || _e === void 0 ? void 0 : _e.route) || (["crossSelling", "shop"].includes((_f = flow.currentRoute) === null || _f === void 0 ? void 0 : _f.route) && hasGroupedShop && !showCategories)) ? 'hidden' : 'scroll',
                })), (isMobile && {
                    height: _height,
                    minHeight: _height, // for iOS Safari and Edge
                    maxHeight: '1200px',
                    overflowX: 'hidden',
                    overflowY: 'scroll'
                })))), ((orientation === 'vertical' || isMobile) && {
                    // this box is the only scrollable part of the widget
                    height: _height,
                    minHeight: _height, // for iOS Safari and Edge
                    maxHeight: '1200px',
                    overflowX: 'hidden',
                    overflowY: ((_g = flow.currentRoute) === null || _g === void 0 ? void 0 : _g.route) == currentRoute && ([
                        //'select',
                        'select1', // for now, the current "static" widget only has a grouped object list on the first page, so hardcode this and fix this properly later on. I'm not sure what's the best way to fix this.
                        // The issue that needs resolving is the scrollbar. I don't want a scrollbar next to the category tabs, only in the content below. But getting those tabs outside of the scrollable part is a bit tricky
                        //    'select2'
                    ].includes((_h = flow.currentRoute) === null || _h === void 0 ? void 0 : _h.route) || (["crossSelling", "shop"].includes((_j = flow.currentRoute) === null || _j === void 0 ? void 0 : _j.route) && hasGroupedShop && !showCategories)) ? 'hidden' : 'scroll',
                })), { padding: 0, maxWidth: '100dvw' }), (widgetMode === 'default' && {
                    // maxWidth: isDesktop ? '500px' : (defaultOpened.mobile ? 'calc(100vw - 40px)' : '100vw'),  // when using the button, we open full screen
                    maxWidth: isDesktop
                        ? orientation === "horizontal" ? '100%' : '500px'
                        : '100vw', // on mobile, the widget is determined on the iframe, not the widget container
                })), (widgetMode === 'standalone' && isDesktop && {
                    maxWidth: '100%',
                    // maxWidth: orientation === 'horizontal' ? '100%' : '500px',
                })), { 
                    // background: orientation === 'horizontal' ? theme.palette.background.default : theme.palette.background.paper,
                    background: theme.palette.background.paper, 
                    // Enabling below will add styled scrollbars to firefix, albeit too wide as "thin" is too wide
                    // But enabling this will break a lot  in Firefox, Edge and other browsers as it will forced show a 
                    // scrollbar even on non-scrollable content, with up and down buttons that can't be disabled etc.
                    // So, no thank you, default scrollbars in Firefox it is.
                    // scrollbarWidth: 'thin',
                    // scrollbarColor: `${theme.palette.primary.main} ${theme.palette.background.paper}`,
                    "&::-webkit-scrollbar": {
                        width: '4px',
                        height: '10px'
                    }, "&::-webkit-scrollbar-thumb": {
                        background: theme.palette.primary.main,
                        borderRadius: '1px'
                    }, "&::-webkit-scrollbar-track": {
                        background: 'transparent'
                    }, "&::-webkit-scrollbar-corner": {
                        background: 'transparent'
                    } }), children: [showSummary && !((_k = flow.currentRoute) === null || _k === void 0 ? void 0 : _k.parentRoute) && (_jsx(BookingSummary, {})), children] }), flow.insideFlow && (_jsx(MobileStepper, { variant: "dots", steps: Math.max(flow.steps, 5), position: "static", activeStep: flow.currentStep, sx: Object.assign({ 
                    // backgroundColor: 'transparent',
                    width: 'calc(100% - 16px)', height: '16px', borderColor: theme.palette.divider, borderWidth: '1px 0 0 0', borderStyle: "solid", paddingTop: '7px', "& .MuiMobileStepper-dots": {
                        margin: '0 auto'
                    } }, (widgetMode === 'standalone' && orientation === "vertical" && {
                    maxWidth: '484px'
                })), nextButton: _jsx(_Fragment, {}), backButton: _jsx(_Fragment, {}) }))] }));
};
export default BasicNav;
